import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-blue-icon',
  templateUrl: './blue-icon.component.html',
  styleUrls: ['./blue-icon.component.scss']
})
export class BlueIconComponent implements OnInit {

  @Input() name: string;

  constructor() { }

  ngOnInit() {
  }

}
